// src/components/ImagePicker.tsx
import React from 'react';
import useImagePicker from '../../../hooks/useImagePicker';
import CDialog from '../../CDialog';

type ImagePickerProps = any

const ImagePicker: React.FC<ImagePickerProps> = (props) => {
  const {
    selectedImages,
    handleImageChange,
    handleRemoveImage,
    fileInputRef,
    handleButtonClick,

    imageState,

    openModalFail,
    setOpenModalFail,
    handleSubmitFail,
  } = useImagePicker(props);
  const {
    multiple = false,
    hideRemoveIcon = false,
    className = '',
    component,
    handleStateFileLoading
  } = props
  const { input, preview, loading } = component || {}

  const renderInput = () => multiple || selectedImages?.length === 0 ? (
    input ? (
      <div onClick={handleButtonClick}>
        {input}
      </div>
    ) : (
      <button
        onClick={handleButtonClick}
        className="mb-4 px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
      >
        {multiple ? 'Upload Images' : 'Upload Image'}
      </button>
    )
  ) : null

  const renderRemove = (uploading: boolean, uuid: string) => !hideRemoveIcon && !uploading && (
    <button
      onClick={() => handleRemoveImage(uuid)}
      className="absolute top-1 right-1 bg-red-500 text-white rounded-full p-1 hover:bg-red-600"
    >
      <svg
        className="w-4 h-4"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M6 18L18 6M6 6l12 12"
        />
      </svg>
    </button>
  )

  const renderLoading = () => {
    if(loading) {
      handleStateFileLoading?.(true)
      return loading
    }
    return (
      <div className="flex justify-center items-center h-full w-full bg-gray-200 rounded-lg">
        <svg
          className="w-6 h-6 text-gray-400 animate-spin"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M12 4v4M12 16v4M4 12h4M16 12h4M5.64 5.64l2.83 2.83M14.53 14.53l2.83 2.83M5.64 18.36l2.83-2.83M14.53 9.47l2.83-2.83"
          />
        </svg>
      </div>
    )
  }

  const renderPreview = ({ uuid, src }: { uuid: string, src: string }) => {
    return preview ? preview({uuid, src}) : (
      <img
        src={src}
        alt="Selected preview"
        className="h-full w-full object-cover rounded-lg"
      />
    )
  }
    
  return (
    <div className={className}>
      {/* Show button only if no single image is selected */}
      {renderInput()}

      <input
        type="file"
        accept="image/*"
        className="hidden"
        onChange={(e) => handleImageChange(e.target.files)}
        multiple={multiple}
        ref={fileInputRef} // Assign ref to the input
      />
      
      {imageState?.length > 0 && (
        <div
          onClick={() => {
            console.log(multiple, hideRemoveIcon, handleButtonClick)
            if (!multiple && hideRemoveIcon) handleButtonClick()
          }}
        >
          {imageState.map(({ uuid, src, uploading }: any) => (
              <div key={uuid}>
                {renderRemove(uploading, uuid)}
                {uploading ? renderLoading() : renderPreview({uuid, src})}
              </div>
            )
          )}
        </div>
      )}
      <CDialog
        open={openModalFail}
        closeModal={() => setOpenModalFail(false)}
        handleSubmit={handleSubmitFail}
      >
        <div className="w-full text-center">
          <p>{('upload_fail')}</p>
        </div>
      </CDialog>
    </div>
  );
};

export default ImagePicker;
